import React from 'react';

function Homepage_Header() {
  return (
    <header className="bg-white-100 py-8">
      <div className="container mx-auto px-4">
        <div className="logo mb-8">
          <img src="/ImageReference/CroppedLogo.png" alt="ZapZappp Logo" className="h-12" />
        </div>
        <div className="hero-content flex flex-col md:flex-row items-center justify-between">
          <div className="hero-text md:mr-8 mb-8 md:mb-0">
            <h1 className="text-4xl font-bold mb-4">YOUR ON-DEMAND<br />VIRTUAL ASSISTANT<br />WORKFORCE</h1>
            <p className="text-xl mb-4">Get tasks done for as low as $6/hour<br />with our expert VA team</p>
            <a 
              href="#pricing-section"
              className="cta-button bg-purple-600 text-white px-6 py-2 rounded-full hover:bg-purple-700 inline-block"
            >
              HIRE NOW!
            </a>
          </div>
          <div className="hero-image">
            <img src="/ImageReference/ZapZappp_Hero.png" alt="Virtual Assistants" className="max-w-md w-full" />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Homepage_Header;
